export default __webpack_public_path__ + "static/media/login.67a928de.png";